<template lang="pug">
.careerCard
  .careerCard-header
    h4.u-mb-ts: AppLink(:to="`/careers/${data.slug}`"  :title="data.title") {{ data.title }}
    p.u-mb-0.careerCard-desc {{ data.description }}
    .u-mt-ts(v-if="data.branchObj && data.branchObj.length")
    .careerCard-branches.u-mb-0(v-if="data.branchObj && data.branchObj.length")
      AppLink.careerCard-branch(v-for="b,idx in data.branchObj" :to="`/company/branches/${b.name.toLowerCase()}`"  :key="idx")
        AppIcon(name='location')
        span(v-if="$i18n.locale === 'ar' && b.nameAr")  {{b.nameAr}}
        span(v-else)  {{b.name}}
  .careerCard-footer
    AppLink(:to="`/careers/${data.slug}`" class="button-link is-small" :title="$t('forms.apply')") {{$t('forms.apply')}}

</template>

<script>
export default {
  name: 'CareersCard',
  props: {
    data: {
      type: [Array, Object],
      required: true
    }
  }
};
</script>

<style lang="stylus">
.careerCard
  border-bottom: 3px solid $clBlack
  display flex
  align-items center
  justify-content space-between
  padding unitRes(20,60) 0
  max-width:80%
  &-header
    flex 1 1 0%
  &-desc
    max-width 1000px
  &-branches
    display flex
    flex-wrap: wrap
    margin 0  -10px
    >*
      display inline-flex
      align-items center
      padding-left 10px
      padding-right 10px
</style>
